<template>
  <div class="panel-item-box">
    <div
      class="title"
      :style="_height"
    >
      <slot name="title" />
    </div>
    <div
      v-if="!noBorder"
      class="divider"
    />
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PanelItem',
  props: {
    noBorder: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    _height() {
      return { height: this.height }
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang='scss' scoped>
.panel-item-box {
	background-color: #fff;
	.title {
		font-family: "Montserrat", sans-serif;
    font-optical-sizing: auto;
		font-size: 20px;
		color: rgba(0, 0, 0, 0.65);
		height: auto;
		padding-left: 48px;
		padding-right: 48px;
		display: flex;
		align-items: center;
	}
	.divider {
		border-top: 1px solid rgba(0, 0, 0, 0.08);
	}
	.content {
		padding: 16px 48px 48px;
	}
}
</style>
